import { isAfter } from '@sequencehq/utils/dates'
import { getBillingDates } from './getBillingDates'

type BillingFrequency =
  | 'ONE_TIME'
  | 'MONTHLY'
  | 'QUARTERLY'
  | 'HALF_YEARLY'
  | 'YEARLY'
  | 'ON_DEMAND'

const orderedBillingFrequencies: BillingFrequency[] = [
  'MONTHLY',
  'QUARTERLY',
  'HALF_YEARLY',
  'YEARLY'
]

export const getNextBillingDateForSchedule = (args: {
  recurrenceDayOfMonth: number
  endDate: Date
  startDate: Date
  today?: Date
  prices: Array<{ billingFrequency: BillingFrequency }>
}): Date | null => {
  const today = args.today ?? new Date()
  const nextBillingPeriod = getBillingDates({
    recurrenceDayOfMonth: args.recurrenceDayOfMonth,
    phaseDates: {
      start: args.startDate,
      end: new Date(args.endDate)
    }
  })

  const smallestBillingFrequency = args.prices.reduce(
    (acc, price) => {
      if (!acc || ['ON_DEMAND', 'ONE_TIME'].includes(price.billingFrequency)) {
        return price.billingFrequency
      }

      /**
       * Find the smallest billing frequency in the array!
       */
      if (
        orderedBillingFrequencies.findIndex(f => f === price.billingFrequency) <
        orderedBillingFrequencies.findIndex(f => f === acc)
      ) {
        return price.billingFrequency
      }

      return acc
    },
    null as BillingFrequency | null
  )

  if (!smallestBillingFrequency) {
    return (
      nextBillingPeriod['MONTHLY'].find(date => isAfter(date, today)) ?? null
    )
  }

  return (
    nextBillingPeriod[smallestBillingFrequency].find(date =>
      isAfter(date, today)
    ) ?? null
  )
}
